import React, { useState } from "react";
import { NavBar, Button } from 'antd-mobile'

import { 
    BodyView,
    InputView,
    ButtonView
} from "../../factory/ViewUtil";
import { ToastContent, ToastLoading, ToastClear, AlertContent } from '../../factory/FactoryUtil';
import { logoutClear, UpdateLoginPassword } from "../../../NetworkFactory";

const MeLoginPasswordController = ({goback, gohome, navpush}) => {
    const forgot = ()=> {
        navpush('/forgot')
    };

    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')

    const PostUpdateLoginPassword = () => {
        if (oldPassword.length < 6 || oldPassword.length > 20 || 
            newPassword.length < 6 || newPassword.length > 20) {
            ToastContent('Login password length [6-20]')
        }
        else if(oldPassword === newPassword) {
            ToastContent('Cannot be the same')
        }
        else {
            ToastLoading('Requesting...')
            UpdateLoginPassword(oldPassword, newPassword).then(response => {
                ToastClear()
                const {status} = response.data || {}
                if(status === 200) {
                    logoutClear()
                    ToastContent('Update Success')
                    gohome()
                } else {
                    AlertContent('Login modification failed, original password mismatch or other abnormalities')
                }
                
            }).catch(() => {
                ToastClear()
            })
        }
    }
    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>Login Password</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <div style={{height : '20px'}}></div>
               <InputView value={oldPassword} onChange={val => {setOldPassword(val)}} clearable type="password" title = 'Old password'/>
               <div style={{height : '20px'}}></div>
               <InputView value={newPassword} onChange={val => {setNewPassword(val)}} clearable type="password" title = 'New password'/>
               <ButtonView onClick={PostUpdateLoginPassword} style = {{width : '100%', marginTop : '15px'}}>Update</ButtonView>

               <div style={{textAlign : 'center'}}>
                    <Button onClick={forgot} color='primary' fill='none' size="small"  style={{marginTop : '10px', color : '#000'}}>Forgot password?</Button>
               </div>

            </BodyView>
        </>
    );
}
export default React.memo(MeLoginPasswordController)